import React from "react";
import BannerImage from "../Assets/slide1.png";
import Navbar from "./Navbar";
import { FiArrowRight } from "react-icons/fi";

const Home = () => {
  return (
    <div className="home-container bg-[#082028]"> {/* Updated background color */}
      <Navbar />
      <div className="flex flex-row items-center justify-between bg-[#082028] p-6 md:p-12"> {/* Updated section background color */}
        {/* Text section */}
        <div className="text-[#D0B070] w-11/12 text-left mt-12 mb-12"> {/* Updated text color */}
          <h1 className="text-l md:text-6xl font-bold mb-4">
            Ngolo Services
          </h1>
          <p className="text-[8px] md:text-xl mb-6">
            Une petite entreprise fondée par des jeunes expertisés et
            passionnés par l'innovation et la technologie. Nous nous consacrons
            à offrir des solutions technologiques sur mesure qui répondent aux
            besoins spécifiques de nos clients, tout en améliorant leur
            quotidien de manière tangible.
          </p>
          <button className="bg-[#D0B070] text-[8px] md:text-2xl hover:bg-[#A89058] text-black py-1 px-1 md:py-2 md:px-4 rounded-full  items-center justify-center  md:mx-0"> {/* Updated button colors */}
            <a href="#ContactForm" className="flex ">
              Contact
            <FiArrowRight className="md:ml-2 md:mt-1 ml-1 mt-[2px]" />
            </a>
          </button>
        </div>

        {/* Image section */}
        <div className="w-full md:w-full mt-6 md:mt-0">
          <img
            src={BannerImage}
            alt="Banner"
            className="w-full h-full rounded-lg shadow-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
